import regeneratorRuntime from "regenerator-runtime";

const BannedWordsComponent = {
  mounted(){
    this.getComponents().then((T) => new T(this.el, {
      editTags: false,
      callbacks: {
        add: () =>
          this.pushEventTo("#"+this.el.id, 'update_banned_words', {banned_words: this.el.value}),
        remove: () =>
          this.pushEventTo("#"+this.el.id, 'update_banned_words', {banned_words: this.el.value})
      }
    }))
  },
  getComponents: async function () {
    const {default: Tagify} = await import('@yaireo/tagify')
    await import("@yaireo/tagify/dist/tagify.css")
    return Tagify;
  },
  disconnected() { console.log('Tagify disconnected') },
  reconnected()  { console.log('Tagify reconnected') },
  updated()      { console.log('Tagify updated') },
  destroyed()    { console.log('Tagify destroyed') }
}

export default { BannedWords: BannedWordsComponent };
